// ===========================================
// Lesson Detail Page Constants
// ===========================================

// Default color for age groups that don't have a custom color
export const DEFAULT_AGE_GROUP_COLOR = '#9DA5AF';
